import Vue from 'vue'
// import App from './components/login/LoginPage.vue'
import App from './App.vue'
import router from './router'
import store from './store'
//import bootstrap from 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/js/fontawesome'
import '@fortawesome/fontawesome-free/js/solid'
import '@fortawesome/fontawesome-free/js/regular'
import '@fortawesome/fontawesome-free/js/brands'
// import 'font-awesome/css/font-awesome.min.css'
import http from '@/http';
import VueMeta from 'vue-meta'
import VueI18n from 'vue-i18n';
import en from '@/i18n/en-US.json'; // 存放英文翻譯
import tw from '@/i18n/zh-TW.json'; // 存放繁體中文翻譯
import kr from '@/i18n/ko-KR.json';
import th from '@/i18n/th-TH.json';
import cn from '@/i18n/zh-CN.json';
import StoreInfo from "@/components/base/store-info.js";
import BaseLayoutComponent from "@/components/base/base-layout-component.js";
import VueQrcodeReader from "vue-qrcode-reader";

const locales = {
  'en-US': en,
  'zh-TW': tw,
  'ko-KR': kr,
  'th-TH': th,
  'zh-CN': cn
};
let messages = {};
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})
Vue.use(VueI18n);
Vue.use(VueQrcodeReader);

Vue.config.lang = window.localStorage["apexlanguage"] || store.state.language || 'zh-TW'
Object.keys(locales).forEach(function (lang) {
  messages[lang] = locales[lang];
  // Vue.locale(lang, locales[lang]);
});
// alert(window.localStorage["apexlanguage"]);
const i18n = new VueI18n({
  locale: window.localStorage["apexlanguage"] || 'en-US', // set locale
  fallbackLocale: 'zh-TW',
  messages, // set locale messages
})



Vue.prototype.$http = http;
Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
  if (to.query.mode === 'install') {
    next({
      path: '/Install',
      // query: { redirect: to.fullPath }
    });
    //alert('install');
  }
  // debugger;
  if (to.meta.requireAuth) {
    if (!store.state.isLogin) {
      next({
        path: '/',
        // query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});
Vue.mixin({
  ...StoreInfo,
  ...BaseLayoutComponent
});
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
